export default __webpack_public_path__ + "static/media/portfolio-img1.099e71cd.jpg";